import moment from 'moment'

/**
 * Retorna ventana si la fecha dada está en alguna de las dos ventanas de modificación
 * @returns ventana ('oct-nov','abr-may') o null si no está en ventana
 */

export function getActiveModificationWindow(date: Date): null | 'oct-nov' | 'abr-may' {
    const year = date.getFullYear()

    // Ventana 1: 11 oct - 10 nov
    const win1Start = moment(`${year}-10-11`)
    const win1End = moment(`${year}-11-10`).endOf('day')

    // Ventana 2: 11 abr - 10 may
    const win2Start = moment(`${year}-04-11`)
    const win2End = moment(`${year}-05-10`).endOf('day')

    if (moment(date).isBetween(win1Start, win1End, undefined, '[]')) return 'oct-nov'
    if (moment(date).isBetween(win2Start, win2End, undefined, '[]')) return 'abr-may'
    return null
}